// extracted by mini-css-extract-plugin
module.exports = {"withIcon":"MessageBoxContainer-withIcon-67ec2918fd2901fe36519d27d2353471","withoutIcon":"MessageBoxContainer-withoutIcon-e84d3a9d9f21d627df3e32331c81a5a9"};